<ng-container [ngSwitch]="notification.payload.attributes.notification_type">
  <app-notification-template [notification]="notification"
                             type="error"
                             *ngSwitchCase="'data_set_usage_disconnected'">
    <ng-container message>
      {{ 'tracking_urls.sources_disconnected' | translate:{ nb_sources: data_set_usages.length } }}
    </ng-container>
    <ng-container action>
      <div class="actions-container">
        <a appClickStopPropagation (click)="onReconnectClick()">{{ 'tracking_urls.reconnect' | translate }}</a>
      </div>
    </ng-container>
  </app-notification-template>
</ng-container>
